import { render, staticRenderFns } from "./BouncingDots.vue?vue&type=template&id=773312d1&scoped=true&"
var script = {}
import style0 from "./BouncingDots.vue?vue&type=style&index=0&id=773312d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773312d1",
  null
  
)

export default component.exports